// import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useProjectStore } from 'Store/Project'
// import Swal from 'sweetalert2'
// import { toast } from 'react-toastify'
// import CustomActionCell from 'Presentation/Components/Table/Components/CustomActionCell'

const ViewModel = () => {
  // const { id } = useParams<{ id: string }>()
  const { data } = useProjectStore(state => ({
    data: state.selected,
  }))

  const columns: any[] = [
    {
      Header: 'ชื่อ-นามสกุล',
      accessor: 'fullName',
      width: 200,
      minWidth: 200,
      disableSortBy: true,
      Cell: ({ value }: any) => <span className='text-gray-800'>{value}</span>,
    },
    {
      Header: 'อีเมล',
      accessor: 'username',
      width: 200,
      minWidth: 200,
      Cell: ({ value }: any) => {
        return <span className='text-gray-800'>{value}</span>
      },
    },
    // {
    //   Header: 'ตำแหน่ง',
    //   accessor: 'roleTitle',
    //   width: 200,
    //   minWidth: 200,
    //   Cell: ({ row }: any) => {
    //     return <span className='text-gray-800'>{row.original.supervisor.roleTitle ?? '-'}</span>
    //   },
    // },
    // {
    //   Header: '',
    //   accessor: 'action',
    //   width: 100,
    //   minWidth: 100,
    //   Cell: ({ row }: any) => (
    //     <CustomActionCell
    //       id={row.original.supervisor.id}
    //       hideView
    //       hideEdit
    //       hideDuplicate
    //       onClickDelete={() => {
    //         onRemoveSiteSupervisor(row.original.supervisor.id)
    //       }}
    //     />
    //   ),
    // },
  ]

  return { data: data?.saleUsers ?? [], columns }
}

export default ViewModel
